<div class="flex flex-col overflow-auto">
  <lla-overview-filters-header
    [tableActions]="tableActions"
    [advancedFilterKey]="advancedFilterKey"
    (clearAllFilters)="clearAllFilters.emit()"
  ></lla-overview-filters-header>

  <div class="flex-1 overflow-auto">
    @for (item of filters; track item) {
      <lla-overview-filters-item
        [advancedFilterKey]="advancedFilterKey"
        [overviewKey]="item"
        [tableActions]="tableActions"
        [filter]="tableFilters[item]"
        (filterChanged)="filterChanged.emit($event)"
        (clearAllFilters)="clearAllFilters.emit()"
      >
      </lla-overview-filters-item>
    }
  </div>
</div>
